import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { accountsEnvironment } from './accounts-environment';
import { accountSummarySchema } from './schemas/account-summary.schema';

export function getSummary() {
  return fromFetch(
    new Request(accountsEnvironment.summaryUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(accountSummarySchema));
}
